
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gqNOF3fEyIwOPzIU1wdRuZdgg9vL54E6IHkYT9U4IzL0Meta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index7azUf3T64CwQ_mw4y9OO8YZ7KkzYVKAzebhEMyzgajQMeta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchRf1KTcm4TSTGfRs_15saSHEIDT2cwTvJgK2qtAmYsIcMeta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexcSW9VUjDLl3E7nPZDL8rstNRaV2r2Vc3gVocpAMBmywMeta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93XJvTPJ6XqLxXAlaRByNIdLQaHtnvY0DZ_lOQ1InytfsMeta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexJ8Ia3_450C7PXLvnzOqrQ8LOlvrv0YVLM0UqTpGlqyIoIMeta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93SdwJ2ARmvx_LYL_45XE4t4nqKhkClbUKqdS94J4ztvP5MMeta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexBFrNa9EtJ4bpKiBsjzUIuOyGOHGHZXasha_45Xu47qs7EMeta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93sxHCbI_AG9qnHRFWl_45_45_jjt1Pd6qQTnn_uZg5HFGw1IMeta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexp192rwYS7nb2Z30_L5QDzbuBowAer8RXjUfWI7_45AGM0Meta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexZl2lUkIZMDW_45mq9TBzn6rbnb5IaN82X1BoeFGZjJqIUMeta } from "/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexJ8Ia3_450C7PXLvnzOqrQ8LOlvrv0YVLM0UqTpGlqyIoIMeta || {},
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexBFrNa9EtJ4bpKiBsjzUIuOyGOHGHZXasha_45Xu47qs7EMeta || {},
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexp192rwYS7nb2Z30_L5QDzbuBowAer8RXjUfWI7_45AGM0Meta || {},
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexZl2lUkIZMDW_45mq9TBzn6rbnb5IaN82X1BoeFGZjJqIUMeta || {},
    component: () => import("/codebuild/output/src3709452807/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]